import RichUpdatesCreator from './RichUpdatesCreator';

export default RichUpdatesCreator;
